import { render, staticRenderFns } from "./voteRelation.vue?vue&type=template&id=04d7f4ce"
import script from "./voteRelation.vue?vue&type=script&lang=js"
export * from "./voteRelation.vue?vue&type=script&lang=js"
import style0 from "./voteRelation.vue?vue&type=style&index=0&id=04d7f4ce&prod&lang=scss"
import style1 from "./voteRelation.vue?vue&type=style&index=1&id=04d7f4ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports